/* istanbul ignore file */
export enum TransactionStatus {
  Confirmed = "Confirmed",
  Error = "Error"
}
